export const STOCK_LABEL_OPTIONS = [
  { id: 'in_stock', label: 'В наявності', adminLabel: 'В наявності' },
  { id: 'ready_to_ship', label: 'Готово до відправлення', adminLabel: 'Готово до відправлення' },
  { id: 'on_order', label: 'Під замовлення', adminLabel: 'Під замовлення' },
  { id: 'out_of_stock', label: 'Немає в наявності', adminLabel: 'Немає в наявності' },
];

const LABEL_MAP = Object.fromEntries(
  STOCK_LABEL_OPTIONS.map((opt) => [opt.id, opt.label]),
);

export const normalizeStockLabel = (stockLabel, inStock) => {
  if (STOCK_LABEL_OPTIONS.some((opt) => opt.id === stockLabel)) {
    return stockLabel;
  }
  return inStock === false ? 'out_of_stock' : 'ready_to_ship';
};

export const getStockLabelText = (stockLabel, inStock) => {
  const key = normalizeStockLabel(stockLabel, inStock);
  return LABEL_MAP[key] || LABEL_MAP.ready_to_ship;
};

export const getStockLabelAdminText = (stockLabel, inStock) => {
  const key = normalizeStockLabel(stockLabel, inStock);
  const opt = STOCK_LABEL_OPTIONS.find((item) => item.id === key);
  return opt?.adminLabel || opt?.label || LABEL_MAP.ready_to_ship;
};

export const isProductPurchasable = (stockLabel, inStock) => (
  normalizeStockLabel(stockLabel, inStock) !== 'out_of_stock'
);

export const stockLabelToInStock = (stockLabel) => stockLabel !== 'out_of_stock';

export const getStockStatusClass = (stockLabel, inStock, styles) => {
  const key = normalizeStockLabel(stockLabel, inStock);
  switch (key) {
    case 'out_of_stock':
      return styles.statusOut;
    case 'on_order':
      return styles.statusOrder;
    case 'in_stock':
      return styles.statusInStock;
    case 'ready_to_ship':
    default:
      return styles.status;
  }
};
